import { Box, Typography, Grid } from '@mui/material';
import ReactPlayer from 'react-player';
import { makeStyles } from 'tss-react/mui';
import React, { forwardRef, useImperativeHandle, useRef, useState, useEffect } from 'react';
import GSTag from '../../GSTag/GSTag';
import { tracking } from '../../../utils/tracking';

const useStyles = makeStyles()({
  root: {},
  header: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 8
  },
  headerXS: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginBottom: 8
  },
  title: {
    width: 'fit-content',
    marginRight: 8
  },
  titleText: {
    fontSize: 24,
    fontWeight: 600
  },
  tagsContainer: {},
  tags: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: 8
  },
  videoPlayer: {
    position: 'relative',
    paddingTop: '56.25%',

    '& > *': {
      position: 'absolute',
      top: 0,
      left: 0
    }
  }
});
export const VideoCardBanner = forwardRef(
  ({ locale, itemData, isMobile, showTags = true, showTitle = true, autoPlay = true, ...props }, ref) => {
    const { title, videoId, tags } = itemData;
    const url = videoId;
    const { classes } = useStyles();
    const playerRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(true);
    const [isLoaded, setIsLoaded] = useState(false);
    const handleSetIsPlaying = isPlaying => {
      setIsPlaying(prev => {
        // console.log("VideoCardBanner handleSetIsPlaying::: ", isPlaying, " isPlaying::: ", prev);
        if (isPlaying !== prev) {
          return isPlaying;
        }
        return prev;
      });
    };

    const eventLayer = {
      component: 'VideoCardBanner',
      event: 'autoplay',
      videoId: videoId,
      title: title[locale],
      tags: tags.map(tag => tag[locale]),
      url: url
    };

    useEffect(() => {
      if (isLoaded) {
        tracking('Video Autoplayed', eventLayer);
        handleSetIsPlaying(true);
      }
    }, [isLoaded]);

    useImperativeHandle(ref, () => ({
      getPlayer: () => playerRef.current,
      setIsPlaying: handleSetIsPlaying
    }));

    return (
      <Box className={classes.root}>
        {(title || tags) && (
          <Box className={isMobile ? classes.headerXS : classes.header}>
            {showTitle && (
              <Box className={classes.title} style={{ width: isMobile ? '100%' : 'fit-content' }}>
                <Typography
                  className={classes.titleText}
                  style={{
                    width: isMobile ? '100%' : 'fit-content'
                  }}
                >
                  {title[locale]}
                </Typography>
              </Box>
            )}
            {showTags && (
              <Box className={classes.tagsContainer} style={{ width: isMobile ? '100%' : 'fit-content' }}>
                <Grid container className={classes.tags}>
                  {tags.map((tag, index) => (
                    <GSTag key={tag.id} label={tag[locale]} color={index} />
                  ))}
                </Grid>
              </Box>
            )}
          </Box>
        )}
        <ReactPlayer
          onPlay={() => {
            handleSetIsPlaying(true);
          }}
          onPause={() => {
            handleSetIsPlaying(false);
          }}
          onReady={() => {
            setIsLoaded(true);
          }}
          // onProgress={progress => {
          //   console.log('Video Progress:', progress);
          //   tracking('Video Progress', {
          //     ...eventLayer,
          //     played: progress.played,
          //     playedSeconds: progress.playedSeconds
          //   });
          // }}
          // progressInterval={5000}
          ref={playerRef}
          url={url}
          className={classes.videoPlayer}
          muted={true}
          playing={isPlaying}
          width="100%"
          height="auto"
          config={{
            youtube: {
              playerVars: {
                controls: 1,
                showinfo: 1,
                enablejsapi: 1,
                origin: 'https://www.youtube.com'
                // origin: window.location.href,
                // widget_referrer: window.location.href,
                // host: `${window.location.protocol}//www.youtube.com`
              }
            }
          }}
        />
      </Box>
    );
  }
);

export default VideoCardBanner;
